import React, { memo } from 'react';
import { FormControlLabel, Paper, Radio } from '@mui/material';
import { useRadioGroup } from '@mui/material/RadioGroup';
import clsx from 'clsx';

import { Loader } from '@monorepo/common';
import { IStep1FieldProps } from '../formInterface';
import { useGetUserInfoQuery } from '../../../../../services/serviceUserInfo';
import { info } from './info';
import { useAppSelector } from '../../../../../store/hooks';

// Tile display names per the approved design (canvas 3a). The 60-day duration is
// stated by the card subtitle ("…Standard or Featured 60-Day Listing.").
const TILE_NAMES = ['Standard Listing', 'Featured Listing'];

export const Step1Field = memo(({ value, extraPrice, currentPrice, dataCy }:IStep1FieldProps) => {
  const { siteNumber } = useAppSelector(({ pathnameSettings }) => ({
    siteNumber: pathnameSettings.siteNumber
  }));
  const { data, isSuccess } = useGetUserInfoQuery();

  // Derive selected state from the enclosing RadioGroup context (visual-only skin;
  // the RadioGroup value / onChange wiring is untouched).
  const radioGroup = useRadioGroup();
  const isFeatured = value === 2;
  const isSelected = radioGroup ? String(radioGroup.value) === String(value) : false;
  const tileClassName = clsx('cpg-tile', {
    'cpg-tile--selected': isSelected,
    'cpg-tile--featured': isFeatured
  });

  if (!isSuccess || !data) return <Loader isShow />;

  const hasDiscount = extraPrice > currentPrice;
  const memberNote = data.isCharterMember
    ? 'Special Charter Member Discount'
    : (data.isSubscriber ? 'Special Insider Member Discount' : null);

  return (
    <Paper
      variant="outlined"
      className={tileClassName}
    >
      {isFeatured && <span className="cpg-badge-amber">Most visible</span>}
      <FormControlLabel
        {...(dataCy) && { 'data-cy': dataCy }}
        control={<Radio />}
        value={value}
        label={(
          <span className="cpg-tile-body">
            <span className="cpg-tile-row">
              <span className="cpg-tile-name">{TILE_NAMES[value - 1]}</span>
              <span className="cpg-tile-price">
                $
                {currentPrice}
                {hasDiscount && (
                  <del className="cpg-tile-price-was">
                    $
                    {extraPrice}
                  </del>
                )}
              </span>
            </span>
            <span className="cpg-tile-desc">{info[value - 1].description(siteNumber)}</span>
            {hasDiscount && memberNote && (
              <span className="cpg-tile-note">{memberNote}</span>
            )}
          </span>
        )}
      />
    </Paper>
  );
});
